"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTablesToExcludeFromSourceTables = exports.getSourceTableOptions = exports.generateKpi = exports.generateDashboardData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const generateDashboardData = (dashboard = {}) => {
    var _a;
    let kpis = dashboard.kpis;
    if (!kpis) {
        let kpiNb = en_1.faker.number.int({
            min: 5,
            max: 7,
        });
        kpis = [];
        for (let i = 0; i < kpiNb; i++) {
            kpis.push((0, exports.generateKpi)({ index: i }));
        }
    }
    return {
        id: dashboard.id || (0, tools_1.IDSource)(),
        name: dashboard.name || en_1.faker.word.words(2),
        title: dashboard.title || en_1.faker.word.words(5),
        description: dashboard.description || en_1.faker.word.words(10),
        active: (_a = dashboard.active) !== null && _a !== void 0 ? _a : true,
        type: dashboard.type ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.DASHBOARD_TYPE)),
        kpis,
        created_at: dashboard.created_at || new Date(),
        updated_at: dashboard.updated_at || new Date(),
    };
};
exports.generateDashboardData = generateDashboardData;
const generateKpi = (kpi) => {
    return {
        type: kpi.type || types_1.KPI_TYPE.SCORECARD,
        tag: kpi.tag || en_1.faker.string.uuid(),
        index: kpi.index || 0,
        query: kpi.query || en_1.faker.word.words(10),
        title: kpi.title || en_1.faker.word.words(5),
        description: kpi.description || en_1.faker.word.words(10),
    };
};
exports.generateKpi = generateKpi;
const getSourceTableOptions = (tables) => {
    const res = [];
    const tablesToExclude = (0, exports.getTablesToExcludeFromSourceTables)();
    const monthlyLogsRegex = new RegExp("log_\\d{4}_\\d{2}");
    tables.forEach((t) => {
        var _a;
        if (!tablesToExclude.includes(t.name) && !monthlyLogsRegex.test(t.name)) {
            res.push({
                key: t.name,
                label: (_a = t.alias) !== null && _a !== void 0 ? _a : "unknown",
            });
        }
    });
    return res.sort((a, b) => a.label.localeCompare(b.label));
};
exports.getSourceTableOptions = getSourceTableOptions;
const getTablesToExcludeFromSourceTables = () => {
    return [
        "notifications",
        "teams_web_users",
        "teams_dashboards",
        "workflows_lists",
        "transformations",
        "dashboards",
        "documents",
        "streams",
        "teams_mobile_users",
        "event_remove_item_owner",
        "items_mobile_users",
        "workflows",
        "activities",
        "items_teams",
        "lists",
        "outdated_workflows",
        "outdated_activities",
        "visit_reports",
        "teams_workflows",
        "teams_documents",
        "mobile_user_location",
        "meta_expressions",
        "reports_mobile_users",
        "reports_teams",
        "visit_workflowreports",
    ];
};
exports.getTablesToExcludeFromSourceTables = getTablesToExcludeFromSourceTables;
